
var { primary, accent } = require('../common.js')

function greet(yargs) {
	var argv = yargs
		.reset()
		.option("last", {
			alias: "l",
			description: "provide a last name"
		})
		.help("help")
		.alias("h")
		.argv

	var first = argv._[1] || 'friend'
	var name = argv.last ? primary(first) + ' ' + accent(argv.last) : primary(first)
	console.log(`Hello, ${name}!`)
}

module.exports = greet


// WEBPACK FOOTER //
// ./src/commands/greet.js